<ng-container [ngSwitch]="variant">
  <section *ngSwitchCase="'tracking-actions'" class="skeleton-loader skeleton-loader--tracking-actions"
    aria-hidden="true">
    <div class="skeleton-loader__tracking-title skeleton-loader__shimmer"></div>

    <div class="skeleton-loader__tracking-step" *ngFor="let item of trackingStateItems">
      <span class="skeleton-loader__tracking-dot skeleton-loader__shimmer"></span>
      <div class="skeleton-loader__tracking-content">
        <span class="skeleton-loader__tracking-line skeleton-loader__tracking-line--title skeleton-loader__shimmer"></span>
        <span class="skeleton-loader__tracking-line skeleton-loader__shimmer"></span>
        <span class="skeleton-loader__tracking-line skeleton-loader__tracking-line--short skeleton-loader__shimmer"></span>
      </div>
    </div>

    <div class="skeleton-loader__tracking-title skeleton-loader__tracking-title--reports skeleton-loader__shimmer"></div>
    <div class="skeleton-loader__tracking-filter skeleton-loader__shimmer"></div>

    <div class="skeleton-loader__tracking-step" *ngFor="let item of trackingReportItems">
      <span class="skeleton-loader__tracking-dot skeleton-loader__shimmer"></span>
      <div class="skeleton-loader__tracking-content">
        <span class="skeleton-loader__tracking-line skeleton-loader__tracking-line--title skeleton-loader__shimmer"></span>
        <span class="skeleton-loader__tracking-line skeleton-loader__shimmer"></span>
      </div>
    </div>

    <div class="skeleton-loader__tracking-button skeleton-loader__shimmer"></div>
    <div class="skeleton-loader__tracking-actions">
      <span class="skeleton-loader__tracking-action skeleton-loader__shimmer" *ngFor="let item of actionItems"></span>
    </div>
  </section>

  <mat-card *ngSwitchCase="'driver-summary'" class="skeleton-loader skeleton-loader__driver-card"
    aria-hidden="true">
    <div class="skeleton-loader__driver-header">
      <span class="skeleton-loader__driver-avatar skeleton-loader__shimmer"></span>
      <div class="skeleton-loader__driver-title-container">
        <span class="skeleton-loader__driver-title skeleton-loader__shimmer"></span>
        <span class="skeleton-loader__driver-subtitle skeleton-loader__shimmer"></span>
      </div>
    </div>

    <section class="skeleton-loader__driver-section">
      <div class="skeleton-loader__driver-section-title skeleton-loader__shimmer"></div>
      <div class="skeleton-loader__driver-rows">
        <span class="skeleton-loader__driver-row skeleton-loader__shimmer" *ngFor="let item of driverBasicRows"></span>
      </div>
    </section>

    <section class="skeleton-loader__driver-section">
      <div class="skeleton-loader__driver-section-title skeleton-loader__shimmer"></div>
      <div class="skeleton-loader__driver-rows">
        <span class="skeleton-loader__driver-row skeleton-loader__shimmer" *ngFor="let item of driverGpsRows"></span>
      </div>
    </section>
  </mat-card>

  <section *ngSwitchDefault class="skeleton-loader skeleton-loader--cargo-list" aria-hidden="true">
    <div class="skeleton-loader__cargo-actions">
      <span class="skeleton-loader__cargo-action skeleton-loader__shimmer"></span>
    </div>

    <article class="skeleton-loader__cargo-card" *ngFor="let item of rowItems">
      <div class="skeleton-loader__cargo-alert skeleton-loader__shimmer"></div>
      <div class="skeleton-loader__cargo-grid">
        <div class="skeleton-loader__cargo-column">
          <span class="skeleton-loader__cargo-pill skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-label skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-value skeleton-loader__shimmer"></span>
        </div>
        <div class="skeleton-loader__cargo-column">
          <span class="skeleton-loader__cargo-pill skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-label skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-value skeleton-loader__shimmer"></span>
        </div>
        <div class="skeleton-loader__cargo-column">
          <span class="skeleton-loader__cargo-pill skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-label skeleton-loader__shimmer"></span>
          <span class="skeleton-loader__cargo-value skeleton-loader__shimmer"></span>
        </div>
      </div>
      <div class="skeleton-loader__cargo-band skeleton-loader__shimmer"></div>
    </article>
  </section>
</ng-container>
